import { render } from "./Document.vue?vue&type=template&id=1d6451dc&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=1d6451dc&scoped=true&lang=css"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6451dc"]])

export default __exports__